import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/img/icon_plus.svg'


const _hoisted_1 = { class: "tableFilters mb-3" }
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = { class: "filter" }
const _hoisted_4 = { class: "filter" }
const _hoisted_5 = { class: "filter" }
const _hoisted_6 = { class: "filter" }
const _hoisted_7 = { class: "filter" }
const _hoisted_8 = { value: "" }
const _hoisted_9 = { class: "buttons d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: ""
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  filter: "createdOn",
  sort: "createdOn",
  filterType: "date"
}
const _hoisted_15 = {
  filter: "name",
  sort: "personalData.name"
}
const _hoisted_16 = {
  filter: "surname",
  sort: "personalData.surname"
}
const _hoisted_17 = {
  filter: "telephone",
  sort: "contactData.telephone"
}
const _hoisted_18 = {
  filter: "email",
  sort: "contactData.email"
}
const _hoisted_19 = {
  filter: "status",
  sort: "status"
}
const _hoisted_20 = {
  filter: "userGestione",
  sort: "reteGestioneParent.name"
}
const _hoisted_21 = {
  filter: "userCommerciale",
  sort: "reteCommercialeParent.name"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { colspan: "99" }
const _hoisted_25 = ["value"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "label"
}
const _hoisted_28 = {
  key: 1,
  class: "label"
}
const _hoisted_29 = {
  key: 0,
  class: "ritardo"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggler = _resolveComponent("toggler")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_op_table = _resolveComponent("op-table")!
  const _directive_leadstatus = _resolveDirective("leadstatus")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_toggler, {
            class: "mr-2",
            modelValue: _ctx.filter.showCustomers,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.showCustomers) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Mostra Clienti",
              text: "Mostra Clienti"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_toggler, {
            class: "mr-2",
            modelValue: _ctx.filter.soloNonFumatori,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter.soloNonFumatori) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Solo NON fumatori",
              text: "Solo NON fumatori"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_toggler, {
            class: "mr-2",
            modelValue: _ctx.filter.showTelephoneOnly,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.showTelephoneOnly) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Solo con numero di telefono",
              text: "Solo con numero di telefono"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_toggler, {
            class: "mr-2",
            modelValue: _ctx.filter.showInRitardoOnly,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filter.showInRitardoOnly) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Solo in ritardo",
              text: "Solo in ritardo"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Substato",
              text: "Substato"
            })
          ]),
          _withDirectives(_createElementVNode("select", {
            class: "label ml-3",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter.subStatusFilter) = $event))
          }, [
            _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$localizationService.GetLocalizedValue("Tutti", "Tutti")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subStatuses, (item, i) => {
              return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(item), 1))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.filter.subStatusFilter]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.$store.state.isAdmin())
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary btn-sm mr-2",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Esporta con filtri selezionati",
                text: "Esporta con filtri selezionati"
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-round",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.newLeadModal && _ctx.newLeadModal(...args)))
        }, _hoisted_11)
      ])
    ]),
    (_ctx.selectedLeads.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("b", null, [
            _createTextVNode(_toDisplayString(_ctx.selectedLeads.length) + " ", 1),
            _createVNode(_component_localized_text, {
              localizedKey: "selezionati:",
              text: "selezionati:"
            })
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.multipleAssignToUser('gestione')))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Assegna gestione",
              text: "Assegna gestione"
            })
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ml-1",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.multipleAssignToUser('commerciale')))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Assegna commerciale",
              text: "Assegna commerciale"
            })
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ml-1",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.multipleAssignToList && _ctx.multipleAssignToList(...args)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Sposta in lista",
              text: "Sposta in lista"
            })
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ml-1",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.changeSubStatusToList && _ctx.changeSubStatusToList(...args)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Cambia substato",
              text: "Cambia substato"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      itemsPerPage: _ctx.filter.perPage,
      items: _ctx.tableResult.data,
      filter: _ctx.filter,
      totalItemsCount: _ctx.tableResult.count,
      onSearch: _ctx.search
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              (_ctx.$store.state.isAdmin() || _ctx.$store.state.isManager())
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-check",
                    onClick: ($event: any) => (_ctx.checkall(opData.items))
                  }, null, 8, _hoisted_13))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_14, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data creazione",
                text: "Data creazione"
              })
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Ultimo trattamento",
                text: "Ultimo trattamento"
              })
            ]),
            _createElementVNode("td", _hoisted_15, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nome",
                text: "Nome"
              })
            ]),
            _createElementVNode("td", _hoisted_16, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cognome",
                text: "Cognome"
              })
            ]),
            _createElementVNode("td", _hoisted_17, [
              _createVNode(_component_localized_text, {
                localizedKey: "Telefono",
                text: "Telefono"
              })
            ]),
            _createElementVNode("td", _hoisted_18, [
              _createVNode(_component_localized_text, {
                localizedKey: "Mail",
                text: "Mail"
              })
            ]),
            _createElementVNode("td", _hoisted_19, [
              _createVNode(_component_localized_text, {
                localizedKey: "Status",
                text: "Status"
              })
            ]),
            _createElementVNode("td", _hoisted_20, [
              _createVNode(_component_localized_text, {
                localizedKey: "Ass. Gestione",
                text: "Ass. Gestione"
              })
            ]),
            _createElementVNode("td", _hoisted_21, [
              _createVNode(_component_localized_text, {
                localizedKey: "Ass. Commerciale",
                text: "Ass. Commerciale"
              })
            ]),
            _hoisted_22
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                _createElementVNode("td", _hoisted_24, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.LeadTableVm[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, [
                (_ctx.$store.state.isAdmin() || _ctx.$store.state.isManager())
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "checkbox",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedLeads) = $event)),
                      value: item.identifier
                    }, null, 8, _hoisted_25)), [
                      [_vModelCheckbox, _ctx.selectedLeads]
                    ])
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(item.role), 1)
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn, 'DD-MM-YYYY')), 1),
              _createElementVNode("td", null, [
                (item.centroTrattamento)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", null, _toDisplayString(item.centroTrattamento.name), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-link btn-sm pl-0",
                          onClick: ($event: any) => (_ctx.centroDetails(item.centroTrattamento))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Contatti",
                            text: "Contatti"
                          })
                        ], 8, _hoisted_26)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, _toDisplayString(item.surname), 1),
              _createElementVNode("td", null, _toDisplayString(item.telephone), 1),
              _createElementVNode("td", null, _toDisplayString(item.email), 1),
              _createElementVNode("td", null, [
                (item.status)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createTextVNode(_toDisplayString(item.status), 1)
                    ])), [
                      [_directive_leadstatus, item]
                    ])
                  : (item.scadenze.length > 0)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createTextVNode(_toDisplayString(_ctx.$filters.date(item.scadenze[0].startDate, "YYYY-MM-DD HH:mm")) + " ", 1),
                        (_ctx.ritardo(item))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, "(" + _toDisplayString(_ctx.ritardo(item)) + ")", 1))
                          : _createCommentVNode("", true)
                      ])), [
                        [_directive_leadstatus, item]
                      ])
                    : _createCommentVNode("", true),
                _createElementVNode("small", null, _toDisplayString(item.subStatus), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", null, _toDisplayString(item.userGestione.name), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-link btn-sm pl-0",
                    onClick: ($event: any) => (_ctx.centroDetails(item.userGestione))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Contatti",
                      text: "Contatti"
                    })
                  ], 8, _hoisted_30)
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", null, _toDisplayString(item.userCommerciale.name), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-link btn-sm pl-0",
                    onClick: ($event: any) => (_ctx.centroDetails(item.userCommerciale))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Contatti",
                      text: "Contatti"
                    })
                  ], 8, _hoisted_31)
                ])
              ]),
              _createElementVNode("td", null, [
                (item.role == 'Lead')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: '/lead/detail/' + item.identifier,
                      class: "btn btn-primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Dettaglio",
                          text: "Dettaglio"
                        })
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: '/clienti/detail/' + item.identifier,
                      class: "btn btn-primary ml-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Dettaglio",
                          text: "Dettaglio"
                        })
                      ]),
                      _: 2
                    }, 1032, ["to"])),
                (_ctx.$store.state.isAdmin())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "btn btn-danger ml-2",
                      onClick: ($event: any) => (_ctx.removeItem(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Elimina",
                        text: "Elimina"
                      })
                    ], 8, _hoisted_32))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["itemsPerPage", "items", "filter", "totalItemsCount", "onSearch"])
  ]))
}